import './SimplePagination.scss';
import classNames from 'classnames';
import { PaginationDirection } from '@sonar-software/sonar-ts-types';
import { When } from 'react-if';
import { Button, Select } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import React, { useState } from 'react';
const pageSizeOptions = [
    {
        label: '10 / page',
        value: 10
    },
    {
        label: '20 / page',
        value: 20
    },
    {
        label: '50 / page',
        value: 50
    },
    {
        label: '100 / page',
        value: 100
    }
];
export const SimplePagination = ({ autoHide, className, defaultPageSize = 20, enableNext, enablePrev, onChange, showSizeChanger = true }) => {
    const [pageSize, setPageSize] = useState(defaultPageSize);
    if (autoHide && !enableNext && !enablePrev) {
        return null;
    }
    return (React.createElement("div", { className: classNames('simple-pagination', className) },
        React.createElement(Button, { disabled: !enablePrev, icon: React.createElement(LeftOutlined, null), onClick: () => onChange(pageSize, PaginationDirection.Backward), size: 'middle' }),
        React.createElement(Button, { disabled: !enableNext, icon: React.createElement(RightOutlined, null), onClick: () => onChange(pageSize, PaginationDirection.Forward), size: 'middle' }),
        React.createElement(When, { condition: showSizeChanger },
            React.createElement(Select, { defaultValue: defaultPageSize, onChange: (value) => {
                    setPageSize(value);
                    onChange(value);
                }, options: pageSizeOptions }))));
};
